import script from "./ImportSubscribers.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportSubscribers.vue?vue&type=script&setup=true&lang=ts"

import "./ImportSubscribers.vue?vue&type=style&index=0&id=b4a3be64&lang=css"

const __exports__ = script;

export default __exports__